module.exports = __webpack_public_path__ + "img/freia.478fd4b4.jpg";